import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { Panel } from 'solar-bo';;
import { SolarService } from '../services/solarservice.service';
import { BaseComponent } from '@solar/shared';
import { ErrorcontrolService } from 'basecomponents';


@Component({
  selector: 'app-panelview',
  templateUrl: './panelview.component.html',
  styleUrls: ['./panelview.component.scss']
})
export class PanelViewComponent extends BaseComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() panel:any;
  @Input() id_panel_type:string="";
  @Input() showflat:boolean=false;


  constructor(private solarService:SolarService) {
    super();
   }

  ngOnInit() {
    this.loading = false;
    if (!this.panel){
      if (this.id_panel_type!=""){
        this.getPanelById(this.id_panel_type);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    let typeChange = changes['panel'];
    if (typeChange && !typeChange.firstChange) {
    }
  }

  ngAfterViewInit(){

  }

  private async getPanelById(id_panel:string){
    this.loading = true;
    this.solarService.panelsTypeById(id_panel)
      .subscribe(
        res => this.getPanelByIdHandleResult(res)
        , err => this.getHandleError(err)
      );
  }

  getPanelByIdHandleResult(panelType: any[]) {
    console.log('getPanelByIdHandleResult', panelType);
    this.panel=panelType[0];//el servicio web devuelve un array en lugar del elemento. Si no lo encuentra devuelve un error generico en lugar de 0 o vacio.
    this.loading = false;
    this.alertmessage = null;
  }
  getHandleError<T>(err: any) {
    this.loading = false;
    this.alertmessage=ErrorcontrolService.basichandleError("", err);
  }

  public static openModal(dialog: MatDialog, panel:any, title?:string, titlesub?:string): MatDialogRef<PanelViewComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "500px";
    //dialogConfig.height = "400px";
    //dialogConfig.data = {entity2edit: entity2edit };

    let dialogRef: MatDialogRef<PanelViewComponent>;
    dialogRef = dialog.open(PanelViewComponent, dialogConfig);
    //dialogRef.componentInstance.configureHeaders(title,titlesub);
    if (typeof(panel)=== "string"){
      dialogRef.componentInstance.id_panel_type=panel;
    }else{
      dialogRef.componentInstance.panel=panel;
    }
    

    return dialogRef;
  }


}
